import { createRouter, RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/store/UserStore'

import Login from "./views/LoginView.vue";
import Dashboard from "./views/DashboardView.vue";
import Wizard from "./views/WizardView.vue";
import NotFound from "./views/NotFound.vue";
import OnePage from "./views/OnePageView.vue";
import GestionTareas from './views/GestionTareasView.vue'
// import ConfigurarTareas from "./views/ConfigurarTareas.vue";
import Configuracion from "./views/ConfiguracionView.vue"
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Dashboard",
    alias: "/Dashboard",
    component: Dashboard
  },
  {
    path: "/Wizard/:Pid",
    name: "Wizard",
    component: Wizard
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound
  },
  {
    path: "/Login",
    name: "Login",
    component: Login
  },
  {
    path: "/OnePage/:Pid",
    name: "OnePage",
    component: OnePage
  },
  {
    path: "/Configuracion",
    name: "Configuracion",
    component: Configuracion
  },
  {
    path: "/GestionTareas/:Pid",
    name: "GestionTareas",
    component: GestionTareas
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});


router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const UserStore = useUserStore();

  
if (UserStore.signedIn) {
  if (to.name === 'Login') {
    next({ name: 'Dashboard' });
  } else if (UserStore.userRoles && UserStore.userRoles.length > 0) {
    next();
  } else if (to.name !== 'Dashboard') {
    next({ name: 'Dashboard' });
  } else {
    next();
  }
} else {
    // Si no está autenticado y va al login, permitimos el acceso
    if (to.name === 'Login') {
      next();
    } else {
      // Guardamos la ruta original antes de redirigir al login
      if (!to.fullPath.startsWith('/code=')) {
        console.log('guarda url:', to.fullPath)
        sessionStorage.setItem('redirectAfterLogin', to.fullPath);
      }
      next({ name: 'Login' });
    }
  }
});





export default router;
